import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { TripStatusBadgeComponent } from 'app/shared/components/trip-status-badge/trip-status-badge.component';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * Trip Status Cell Renderer
 *
 * Renders route, user, and responsible information using UserRouteDisplayComponent
 *
 * @example
 * ```typescript
 * {
 *   field: 'statusTripId',
 *   headerName: 'Estado',
 *   cellRenderer: TripStatusCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-trip-status-cell-renderer',
  standalone: true,
  imports: [CommonModule, TripStatusBadgeComponent],
  template: `
   <app-trip-status-badge [statusTripId]="params.data?.statusTripId"></app-trip-status-badge>
  `,
})
export class TripStatusCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;
}
